import {useState, useEffect, useRef} from 'react'
import {Link} from "react-router-dom"
import CustomAvatar from '@src/views/components/CustomAvatar'
import {ArchiveIcon, UnarchiveIcon} from '@src/views/components/ArchiveIcons'
import {useDispatch, useSelector} from 'react-redux'
import {
    selectChatFromServer,
    selectedContactDetail,
    changeReduxState,
    archiveConversation,
    unarchiveConversation,
    getMassMessageDetail
} from './store/actions'
import {NULL} from './store/actionTypes'
import classnames from 'classnames'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {X, Search, Users, Archive, Inbox, Send, CornerUpLeft} from 'react-feather'
import {
    InputGroup, InputGroupAddon, Input, InputGroupText, Badge, Spinner, Nav, NavItem, NavLink
} from 'reactstrap'
import BlankProfile from "@src/assets/images/avatars/avatar-blank.png"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {PropTypes} from "prop-types"

const TABS = [
    {key: 'inbox', label: 'Inbox', icon: <Inbox size={14}/>},
    {key: 'sent', label: 'Sent', icon: <Send size={14}/>},
    {key: 'archive', label: 'Archive', icon: <ArchiveIcon size={14}/>}
]

const SidebarLeft = props => {
    const {store, sidebar, handleSidebar, userSidebarLeft, handleUserSidebarLeft, chatContacts, selectedUserID, activeTab, onTabChange} = props

    const sweetAlert = withReactContent(Swal)

    const dispatch = useDispatch()

    const chatBrandsStoreSlice = useSelector(state => state.chatBrands)

    const [query, setQuery] = useState('')
    const [active, setActive] = useState({})
    const [contactsOfBrands, setContactsOfBrands] = useState([])
    const [contactsOfBrandsForSearching, setContactsOfBrandsForSearching] = useState([])
    const [loader, setLoader] = useState(true)

    const chatOnLoad = useRef(true)

    const handleUserClick = (type, contact) => {
        dispatch(changeReduxState(NULL.LOAD_SELECTED_USER_CHAT, true))
        if (contact?.is_mass_group || contact?.user_type === 'mass') {
            const massId = String(contact.chat_user).replace('mass_', '')
            dispatch(getMassMessageDetail(massId))
        } else {
            dispatch(selectChatFromServer(contact.chat_user))
            dispatch(selectedContactDetail(contact))
        }
        setActive({type, id: contact.chat_user})
        if (sidebar === true) {
            handleSidebar()
        }
        dispatch({type: 'CLEAR_BRAND_CHAT_COUNT_ON_CLICK', payload: contact})
    }

    const handleArchive = (e, chatUser) => {
        e.stopPropagation()
        sweetAlert.fire({
            title: 'Archive this thread?',
            text: 'It will be moved to your Archive tab.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Archive',
            cancelButtonText: 'Cancel'
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(archiveConversation(chatUser))
                const isCurrentlyOpened = active?.id === chatUser || parseInt(selectedUserID) === chatUser
                if (isCurrentlyOpened && onTabChange) {
                    onTabChange('archive')
                }
            }
        })
    }

    const handleUnarchive = (e, chatUser) => {
        e.stopPropagation()
        sweetAlert.fire({
            title: 'Unarchive this thread?',
            text: 'It will be moved back to your Inbox.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Unarchive',
            cancelButtonText: 'Cancel'
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(unarchiveConversation(chatUser))
            }
        })
    }

    useEffect(() => {
        const error = chatBrandsStoreSlice?.contactLoadError?.response?.status
        if (error && error !== 401) {
            sweetAlert.fire({
                title: 'Connection Error!',
                icon: 'error',
                html: '<p>Please reload the page.</p>',
                confirmButtonText: 'Reload',
                allowOutsideClick: false,
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload()
                }
            })
            dispatch({type: "BRAND_CONTACT_LOAD_ERROR_RESET"})
            setLoader(false)
        }
    }, [chatBrandsStoreSlice])

    useEffect(() => {
        if (!!chatContacts && !!selectedUserID && chatOnLoad.current) {
            chatOnLoad.current = false
            const contact = chatContacts.data.filter(contact => contact.chat_user === parseInt(selectedUserID))
            setActive(null)
            if (contact && contact.length > 0) {
                handleUserClick('contact', contact[0])
            } else {
                dispatch(changeReduxState(NULL.LOAD_SELECTED_USER_CHAT, true))
                dispatch(selectChatFromServer(parseInt(selectedUserID)))
                setActive({type: 'contact', id: parseInt(selectedUserID)})
            }
        }

        if (!!chatContacts) {
            setContactsOfBrands(chatContacts.data || [])
            setContactsOfBrandsForSearching(chatContacts.data || [])
            setLoader(false)
        }
    }, [chatContacts])

    const renderContacts = () => {
        return contactsOfBrands?.map(item => {
            return (
                <li className={classnames({active: active.type === 'contact' && active.id === item?.chat_user})}
                    key={item?.chat_user}
                    style={{position: 'relative'}}>
                    <button className='btn d-flex p-0 w-100 text-left align-items-center' onClick={() => handleUserClick('contact', item)}>
                        {item.is_mass_group ? (
                            <CustomAvatar
                                name="Mass Message"
                                img={null}
                                imgHeight='42'
                                imgWidth='42'
                                className="chat-img-animation"
                            />
                        ) : (
                            <Link to={`/dashboard/brands/nutritions/${item?.chat_user}`} title="Go to profile"
                                  onClick={(e) => e.stopPropagation()}>
                                <CustomAvatar
                                    name={item?.name || item?.rd_name}
                                    img={item?.profile_image || item?.profile_img}
                                    imgHeight='42'
                                    imgWidth='42'
                                    className="chat-img-animation"
                                />
                            </Link>
                        )}
                        <div className='chat-info flex-grow-1'>
                            <h5 className='mb-0'>{item?.name || item?.rd_name}</h5>
                            {item?.last_message && (
                                <span className={classnames('small text-truncate d-block', {
                                    'text-white': active.type === 'contact' && active.id === item?.chat_user,
                                    'text-muted': !(active.type === 'contact' && active.id === item?.chat_user)
                                })}>
                                    {item?.last_message}
                                </span>
                            )}
                        </div>
                        <div className='chat-meta text-nowrap d-flex flex-column align-items-end'>
                            {item?.unread_messages > 0 && (
                                <Badge className='float-right' color='danger' pill>
                                    {item?.unread_messages}
                                </Badge>
                            )}
                            {activeTab !== 'archive' ? (
                                <button
                                    className='btn btn-link p-0 mt-1 archive-btn'
                                    title='Archive thread'
                                    onClick={(e) => handleArchive(e, item?.chat_user)}
                                >
                                    <ArchiveIcon size={14}/>
                                </button>
                            ) : (
                                <button
                                    className='btn btn-link p-0 mt-1 unarchive-btn'
                                    title='Unarchive thread (Move back to Inbox)'
                                    onClick={(e) => handleUnarchive(e, item?.chat_user)}
                                >
                                    <UnarchiveIcon size={14}/>
                                </button>
                            )}
                        </div>
                    </button>
                </li>
            )
        })
    }

    const handleFilter = e => {
        setQuery(e.target.value)
        const val = e.target.value.toLowerCase()
        setContactsOfBrands(contactsOfBrandsForSearching.filter(contact => (contact.name || contact.rd_name || '').toLowerCase().includes(val)))
    }

    return store ? (
        <div className='sidebar-left'>
            <div className='sidebar'>
                <div className={classnames('sidebar-content', {show: sidebar === true})}>
                    <div className='sidebar-close-icon'>
                        <button className='btn btn-link p-0 bg-danger rounded-circle text-white' onClick={handleSidebar}>
                            <X/>
                        </button>
                    </div>
                    <div className='chat-fixed-search'>
                        <div className='d-flex align-items-center w-100'>
                            <InputGroup className='input-group-merge'>
                                <InputGroupAddon addonType='prepend'>
                                    <InputGroupText className='round'>
                                        <Search className='text-muted' size={14}/>
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    value={query}
                                    className='round'
                                    placeholder='Search conversations'
                                    onChange={handleFilter}
                                />
                            </InputGroup>
                        </div>
                    </div>
                    <div className='d-flex border-bottom justify-content-between align-items-center'>
                        <h4 className='chat-list-title m-0 p-1'>
                            <Users size='18'/> Conversations
                        </h4>
                        {loader && (
                            <span className='m-0 p-1'>
                                <Spinner color='primary' style={{height: '16px', width: '16px'}}/>
                            </span>
                        )}
                    </div>
                    {/* Inbox / Sent / Archive Tabs */}
                    <Nav tabs className='px-1 pt-1 border-bottom-0'>
                        {TABS.map(tab => (
                            <NavItem key={tab.key}>
                                <NavLink
                                    className={classnames('d-flex align-items-center', {active: activeTab === tab.key})}
                                    style={{cursor: 'pointer', fontSize: '12px', padding: '4px 8px'}}
                                    onClick={() => {
                                        if (activeTab !== tab.key) {
                                            setLoader(true)
                                            onTabChange(tab.key)
                                        }
                                    }}
                                >
                                    {tab.icon}&nbsp;{tab.label}
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                    <PerfectScrollbar className='chat-user-list-wrapper list-group' options={{wheelPropagation: false}}>
                        {loader ? (
                            <div className='py-1'>
                                {[1, 2, 3, 4, 5].map((i) => (
                                    <div key={i} className='skeleton-item'>
                                        <div className='skeleton-avatar' />
                                        <div className='skeleton-info'>
                                            <div className='skeleton-line title' />
                                            <div className='skeleton-line subtitle' />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <ul className='chat-users-list contact-list media-list pb-4'>
                                {contactsOfBrands?.length > 0 ? (
                                    renderContacts()
                                ) : (
                                    <li className='text-center py-3 text-muted border-top-0' style={{ fontSize: '0.85rem', listStyle: 'none' }}>
                                        No conversations found
                                    </li>
                                )}
                                <li className='text-center py-2 text-muted border-top-0 mt-1' style={{ fontSize: '0.85rem', listStyle: 'none', paddingBottom: '30px' }}>
                                    Total Conversations: {contactsOfBrands?.length || 0}
                                </li>
                            </ul>
                        )}
                    </PerfectScrollbar>
                </div>
            </div>
        </div>
    ) : null
}

SidebarLeft.propTypes = {
    store: PropTypes.object.isRequired,
    sidebar: PropTypes.bool.isRequired,
    handleSidebar: PropTypes.func.isRequired,
    userSidebarLeft: PropTypes.bool.isRequired,
    handleUserSidebarLeft: PropTypes.func.isRequired,
    chatContacts: PropTypes.shape({
        data: PropTypes.arrayOf(
            PropTypes.shape({
                chat_user: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
                profile_image: PropTypes.string,
                profile_img: PropTypes.string,
                name: PropTypes.string,
                rd_name: PropTypes.string,
                unread_messages: PropTypes.number
            })
        )
    }),
    selectedUserID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    activeTab: PropTypes.string,
    onTabChange: PropTypes.func
}

export default SidebarLeft